import './styles.scss';
import Header from '../../components/Header'
import Cover from '../../components/Cover'
import About from '../../components/About';
import Fields from '../../components/Fields';
import Symptoms from '../../components/Symptoms';
import Treatments from '../../components/Treatments';
import Feedback from '../../components/Feedback';
import Location from '../../components/Location';
import Questions from '../../components/Questions';
import Footer from '../../components/Footer';

function Home() {
    return (
        <>
            <Header />
            <div className='container-home'>
                <div className='btn-whatsapp'>
                    <a href='https://wa.me/5571997303062' target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp"></i></a>
                </div>
                <Cover />
                <About />
                <Fields />
                <Symptoms />
                <Treatments />
                <Feedback />
                <Questions />
                <Location />
            </div>
            <Footer />
        </>
    );
}

export default Home;
